// Production environment. Can be overridden by useLocalEnv
let api_endpoint = "https://api-dazzle.zebrain.se/api/";
let file_host = "https://customerportal.zebrain.se/";
let app_host = "https://customerportal.zebrain.se/";
let system = "prod";

if (window.location.hostname === "localhost") {
  api_endpoint = "http://localhost:8070/api/";
  file_host = "http://localhost/";
  app_host = "http://localhost:1237/";
  system = "dev";
} else if (window.location.hostname === "customerportal-stage.zebrain.se") {
  api_endpoint = "https://backoffice.zebrain.se/api/";
  file_host = "https://customerportal-stage.zebrain.se/";
  app_host = "https://customerportal-stage.zebrain.se/";
  system = "stage";
}

export interface AppConfig {
  API_ENDPOINT: string
  FILE_HOST: string
  APP_HOST: string
  AUTH0_CLIENT_ID: string
  SYSTEM: string
}

export const CONFIG: AppConfig = {
  API_ENDPOINT: api_endpoint,
  FILE_HOST: file_host,
  APP_HOST: app_host,
  SYSTEM: system,
  AUTH0_CLIENT_ID: "gL2YmT08MGR5YvIMUQOTx1LHwfwHArna"
}